module.exports = __webpack_public_path__ + "img/2.4d78ff1c.png";